"use client";
import { buildProvider } from "@jetblue/dotcom-config";
import type { Config } from "@jetblue/dotcom-config/dotcom";

const { ClientConfigProvider, useConfig } = buildProvider<Config>();

export { ClientConfigProvider, useConfig };
